import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  FaArrowLeft,
  FaShieldAlt,
  FaDatabase,
  FaUserLock,
  FaShareAlt,
  FaUserCheck,
  FaEnvelope,
  FaCookieBite,
  FaCheckCircle,
} from "react-icons/fa";

const styles = `
  :root {
    --privacy-primary: #ff5f91;
    --privacy-primary-dark: #ea477d;
    --privacy-light: #fff0f5;
    --privacy-dark: #25182f;
    --privacy-text: #625967;
    --privacy-border: #f0e5eb;
    --privacy-white: #ffffff;
  }

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    background: #fff8fb;
  }

  .privacy-page {
    min-height: 100vh;
    padding-bottom: 60px;
    color: var(--privacy-dark);
    background:
      radial-gradient(
        circle at 100% 0%,
        rgba(255, 95, 145, 0.14),
        transparent 30%
      ),
      linear-gradient(180deg, #ffffff 0%, #fff8fb 100%);
    font-family: Arial, Helvetica, sans-serif;
  }

  .privacy-header {
    position: sticky;
    top: 0;
    z-index: 100;
    background: rgba(255, 255, 255, 0.96);
    border-bottom: 1px solid var(--privacy-border);
    backdrop-filter: blur(14px);
  }

  .privacy-header-content {
    width: min(1100px, calc(100% - 40px));
    min-height: 72px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }

  .privacy-brand {
    display: flex;
    align-items: center;
    gap: 11px;
    color: var(--privacy-dark);
    text-decoration: none;
    font-size: 21px;
    font-weight: 800;
  }

  .privacy-brand-icon {
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    background: linear-gradient(
      135deg,
      var(--privacy-primary),
      var(--privacy-primary-dark)
    );
    border-radius: 14px;
    box-shadow: 0 8px 20px rgba(255, 95, 145, 0.25);
  }

  .privacy-brand span span {
    color: var(--privacy-primary);
  }

  .privacy-language {
    display: flex;
    align-items: center;
    padding: 4px;
    background: var(--privacy-light);
    border-radius: 999px;
  }

  .privacy-language button {
    width: 42px;
    height: 34px;
    border: none;
    border-radius: 999px;
    background: transparent;
    color: var(--privacy-text);
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
    transition: all 0.25s ease;
  }

  .privacy-language button.active {
    color: white;
    background: var(--privacy-primary);
    box-shadow: 0 5px 12px rgba(255, 95, 145, 0.25);
  }

main.privacy-container {
  width: min(1100px, calc(100% - 48px)) !important;
  max-width: 1100px !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  background: transparent !important;
}

  .privacy-hero {
    padding: 70px 0 40px;
    text-align: center;
  }

  .privacy-hero-icon {
    width: 78px;
    height: 78px;
    margin: 0 auto 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    background: linear-gradient(
      135deg,
      var(--privacy-primary),
      var(--privacy-primary-dark)
    );
    border-radius: 24px;
    font-size: 32px;
    box-shadow:
      0 20px 40px rgba(255, 95, 145, 0.25),
      0 0 0 12px rgba(255, 95, 145, 0.07);
  }

  .privacy-hero h1 {
    margin: 0;
    font-size: clamp(35px, 5vw, 54px);
    line-height: 1.12;
    letter-spacing: -1.8px;
  }

  .privacy-hero p {
    max-width: 650px;
    margin: 18px auto 0;
    color: var(--privacy-text);
    font-size: 17px;
    line-height: 1.75;
  }

  .privacy-card {
    width: 100%;
    margin: 0 auto 22px;
    padding: 34px 38px;
    background: rgba(255, 255, 255, 0.97);
    border: 1px solid var(--privacy-border);
    border-radius: 22px;
    box-shadow: 0 14px 40px rgba(62, 34, 50, 0.07);
    transition:
      transform 0.25s ease,
      box-shadow 0.25s ease;
  }

  .privacy-card p,
.privacy-card li {
  font-size: 16px;
  line-height: 1.8;
}

  .privacy-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 18px 48px rgba(62, 34, 50, 0.11);
  }

  .privacy-card-header {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 18px;
  }

  .privacy-section-icon {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--privacy-primary);
    background: var(--privacy-light);
    border-radius: 15px;
    font-size: 20px;
  }

  .privacy-card h2 {
    margin: 0;
    font-size: 21px;
    line-height: 1.3;
  }

  .privacy-card p {
    margin: 0;
    color: var(--privacy-text);
    font-size: 15px;
    line-height: 1.8;
  }

  .privacy-card ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 13px;
  }

  .privacy-card li {
    display: flex;
    align-items: flex-start;
    gap: 11px;
    color: var(--privacy-text);
    font-size: 15px;
    line-height: 1.65;
  }

  .privacy-card li svg {
    flex-shrink: 0;
    margin-top: 4px;
    color: var(--privacy-primary);
  }

  .privacy-contact {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    margin-top: 16px;
    padding: 12px 16px;
    color: var(--privacy-primary-dark);
    background: var(--privacy-light);
    border-radius: 14px;
    font-weight: 700;
    text-decoration: none;
  }

  .privacy-contact:hover {
    text-decoration: underline;
  }

  .privacy-actions {
    margin-top: 36px;
    display: flex;
    justify-content: center;
  }

  .privacy-back-button {
    min-height: 52px;
    padding: 0 26px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: white;
    background: linear-gradient(
      135deg,
      var(--privacy-primary),
      var(--privacy-primary-dark)
    );
    border-radius: 999px;
    text-decoration: none;
    font-size: 15px;
    font-weight: 800;
    box-shadow: 0 14px 28px rgba(255, 95, 145, 0.26);
    transition: all 0.25s ease;
  }

  .privacy-back-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 18px 35px rgba(255, 95, 145, 0.34);
  }

  .privacy-footer {
    margin-top: 55px;
    text-align: center;
    color: #928790;
    font-size: 13px;
  }

  @media (max-width: 700px) {
    .privacy-header-content,
    .privacy-container {
      width: calc(100% - 28px);
    }

    .privacy-header-content {
      min-height: 66px;
    }

    .privacy-brand {
      font-size: 18px;
    }

    .privacy-brand-icon {
      width: 38px;
      height: 38px;
    }

    .privacy-hero {
      padding: 50px 0 30px;
    }

    .privacy-hero-icon {
      width: 68px;
      height: 68px;
      font-size: 28px;
    }

    .privacy-card {
      padding: 23px 20px;
      border-radius: 18px;
    }

    .privacy-card-header {
      align-items: flex-start;
    }

    .privacy-card h2 {
      font-size: 19px;
    }

    .privacy-section-icon {
      width: 43px;
      height: 43px;
    }

    .privacy-back-button {
      width: 100%;
    }
  }
`;

const translations = {
  en: {
    title: "Privacy Policy",
    subtitle:
      "Learn how MyHalal collects, uses, protects and manages your personal information.",

    collectTitle: "1. Information We Collect",
    collectItems: [
      "Personal information such as your name, age, gender and location.",
      "Account information including your email address and login details.",
      "Profile content such as your biography, preferences and uploaded photos.",
      "Usage information about how you interact with the platform.",
      "Technical information including browser, device and IP-related data.",
      "Cookies and similar technologies used to improve your experience.",
    ],

    useTitle: "2. How We Use Your Information",
    useItems: [
      "To create and manage your MyHalal account.",
      "To provide profile suggestions and matchmaking features.",
      "To enable messaging, calls and other platform services.",
      "To improve performance, security and user experience.",
      "To communicate with you about your account or service updates.",
      "To prevent fraud, abuse and unauthorized activity.",
      "To comply with applicable legal obligations.",
    ],

    sharingTitle: "3. Sharing of Information",
    sharingItems: [
      "We do not sell your personal information.",
      "We may share limited information with trusted service providers when necessary to operate the platform.",
      "We may disclose information when required by law or to protect users and the platform.",
      "We may share information with your consent or at your direction.",
    ],

    rightsTitle: "4. Your Privacy Rights",
    rightsItems: [
      "Request access to the personal information we hold about you.",
      "Request correction of inaccurate or incomplete information.",
      "Request deletion of your account and eligible personal information.",
      "Request a copy of certain personal information.",
      "Update your preferences and profile information.",
      "Withdraw consent where processing is based on consent.",
    ],

    securityTitle: "5. Data Security",
    securityText:
      "We use reasonable technical and organizational measures to protect your personal information. However, no online system can guarantee complete security, so users should also protect their passwords and account access.",

    retentionTitle: "6. Data Retention",
    retentionText:
      "We retain personal information only for as long as necessary to provide our services, comply with legal obligations, resolve disputes and protect the platform.",

    cookiesTitle: "7. Cookies",
    cookiesText:
      "MyHalal may use cookies and similar technologies to remember preferences, maintain sessions, analyze usage and improve platform performance.",

    contactTitle: "8. Contact Us",
    contactText:
      "For questions about this Privacy Policy or your personal information, contact us at:",

    back: "Return to registration",
    rights: "All rights reserved.",
  },

  fr: {
    title: "Politique de confidentialité",
    subtitle:
      "Découvrez comment MyHalal collecte, utilise, protège et gère vos informations personnelles.",

    collectTitle: "1. Informations que nous collectons",
    collectItems: [
      "Les informations personnelles telles que votre nom, votre âge, votre sexe et votre localisation.",
      "Les informations de compte, notamment votre adresse e-mail et vos identifiants de connexion.",
      "Le contenu de votre profil, notamment votre biographie, vos préférences et vos photos.",
      "Les données d’utilisation concernant votre interaction avec la plateforme.",
      "Les informations techniques liées au navigateur, à l’appareil et à l’adresse IP.",
      "Les cookies et technologies similaires utilisés pour améliorer votre expérience.",
    ],

    useTitle: "2. Comment nous utilisons vos informations",
    useItems: [
      "Créer et gérer votre compte MyHalal.",
      "Fournir des suggestions de profils et des fonctionnalités de mise en relation.",
      "Permettre la messagerie, les appels et les autres services de la plateforme.",
      "Améliorer les performances, la sécurité et l’expérience utilisateur.",
      "Communiquer avec vous au sujet de votre compte ou des mises à jour du service.",
      "Prévenir la fraude, les abus et les activités non autorisées.",
      "Respecter les obligations légales applicables.",
    ],

    sharingTitle: "3. Partage des informations",
    sharingItems: [
      "Nous ne vendons pas vos informations personnelles.",
      "Nous pouvons partager certaines informations avec des prestataires de confiance lorsque cela est nécessaire au fonctionnement de la plateforme.",
      "Nous pouvons divulguer des informations lorsque la loi l’exige ou afin de protéger les utilisateurs et la plateforme.",
      "Nous pouvons partager des informations avec votre consentement ou à votre demande.",
    ],

    rightsTitle: "4. Vos droits",
    rightsItems: [
      "Demander l’accès aux informations personnelles que nous détenons sur vous.",
      "Demander la correction d’informations inexactes ou incomplètes.",
      "Demander la suppression de votre compte et des informations admissibles.",
      "Demander une copie de certaines informations personnelles.",
      "Modifier vos préférences et les informations de votre profil.",
      "Retirer votre consentement lorsque le traitement repose sur celui-ci.",
    ],

    securityTitle: "5. Sécurité des données",
    securityText:
      "Nous utilisons des mesures techniques et organisationnelles raisonnables pour protéger vos informations personnelles. Toutefois, aucun système en ligne ne peut garantir une sécurité totale. Vous devez également protéger votre mot de passe et l’accès à votre compte.",

    retentionTitle: "6. Conservation des données",
    retentionText:
      "Nous conservons les informations personnelles uniquement pendant la durée nécessaire pour fournir nos services, respecter nos obligations légales, résoudre les litiges et protéger la plateforme.",

    cookiesTitle: "7. Cookies",
    cookiesText:
      "MyHalal peut utiliser des cookies et des technologies similaires afin de mémoriser vos préférences, maintenir votre session, analyser l’utilisation et améliorer les performances de la plateforme.",

    contactTitle: "8. Nous contacter",
    contactText:
      "Pour toute question concernant cette Politique de confidentialité ou vos informations personnelles, contactez-nous à l’adresse suivante :",

    back: "Retour à l’inscription",
    rights: "Tous droits réservés.",
  },
};

function PrivacyPolicy() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");

    if (savedLanguage === "fr" || savedLanguage === "en") {
      i18n.changeLanguage(savedLanguage);
      return;
    }

    const browserLanguage = (
      navigator.language ||
      navigator.userLanguage ||
      "en"
    ).toLowerCase();

    const detectedLanguage = browserLanguage.startsWith("fr")
      ? "fr"
      : "en";

    i18n.changeLanguage(detectedLanguage);
    localStorage.setItem("language", detectedLanguage);
  }, [i18n]);

  const currentLanguage = i18n.language?.startsWith("fr")
    ? "fr"
    : "en";

  const text = translations[currentLanguage];

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem("language", language);
  };

  return (
    <>
      <style>{styles}</style>

      <div className="privacy-page">
        <header className="privacy-header">
          <div className="privacy-header-content">
            <Link to="/" className="privacy-brand">
              <div className="privacy-brand-icon">
                <FaShieldAlt />
              </div>

              <span>
                My<span>Halal</span>
              </span>
            </Link>

            <div className="privacy-language">
              <button
                type="button"
                className={currentLanguage === "fr" ? "active" : ""}
                onClick={() => changeLanguage("fr")}
              >
                FR
              </button>

              <button
                type="button"
                className={currentLanguage === "en" ? "active" : ""}
                onClick={() => changeLanguage("en")}
              >
                EN
              </button>
            </div>
          </div>
        </header>

        <main className="privacy-container">
          <section className="privacy-hero">
            <div className="privacy-hero-icon">
              <FaUserLock />
            </div>

            <h1>{text.title}</h1>
            <p>{text.subtitle}</p>
          </section>

          <PrivacySection
            icon={<FaDatabase />}
            title={text.collectTitle}
            items={text.collectItems}
          />

          <PrivacySection
            icon={<FaUserCheck />}
            title={text.useTitle}
            items={text.useItems}
          />

          <PrivacySection
            icon={<FaShareAlt />}
            title={text.sharingTitle}
            items={text.sharingItems}
          />

          <PrivacySection
            icon={<FaUserLock />}
            title={text.rightsTitle}
            items={text.rightsItems}
          />

          <PrivacyTextSection
            icon={<FaShieldAlt />}
            title={text.securityTitle}
            text={text.securityText}
          />

          <PrivacyTextSection
            icon={<FaDatabase />}
            title={text.retentionTitle}
            text={text.retentionText}
          />

          <PrivacyTextSection
            icon={<FaCookieBite />}
            title={text.cookiesTitle}
            text={text.cookiesText}
          />

          <section className="privacy-card">
            <div className="privacy-card-header">
              <div className="privacy-section-icon">
                <FaEnvelope />
              </div>

              <h2>{text.contactTitle}</h2>
            </div>

            <p>{text.contactText}</p>

            <a
              href="mailto:info@halalheart.online"
              className="privacy-contact"
            >
              <FaEnvelope />
              info@halalheart.online
            </a>
          </section>

          <div className="privacy-actions">
            <Link to="/register" className="privacy-back-button">
              <FaArrowLeft />
              {text.back}
            </Link>
          </div>

          <footer className="privacy-footer">
            © {new Date().getFullYear()} MyHalal. {text.rights}
          </footer>
        </main>
      </div>
    </>
  );
}

const PrivacySection = ({ icon, title, items }) => (
  <section className="privacy-card">
    <div className="privacy-card-header">
      <div className="privacy-section-icon">{icon}</div>
      <h2>{title}</h2>
    </div>

    <ul>
      {items.map((item) => (
        <li key={item}>
          <FaCheckCircle />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  </section>
);

const PrivacyTextSection = ({ icon, title, text }) => (
  <section className="privacy-card">
    <div className="privacy-card-header">
      <div className="privacy-section-icon">{icon}</div>
      <h2>{title}</h2>
    </div>

    <p>{text}</p>
  </section>
);

export default PrivacyPolicy;